import { API_URL } from '../../../utils/config';

export const GET_LOS_URL = `${API_URL}/los/getlos/1?`;
export const GET_REGIONS_URL = `https://ghanaregionsandcapitals.phirmware.now.sh/`;
export const NIGERIAN_STATES_URL = `https://nigerian-states-info.herokuapp.com/api/v1/states`;
export const GET_NO_LOS_URL = `${API_URL}/los/getlos`;
